import methodology from './methodology.json';

// Explicit equivalences only. A missing sector is unsupported, never a generic multiple.
// The keys are marketplace sectors; values are the original private financial profiles.
export const SECTOR_PROFILES = {
  'hosteleria-y-restauracion': ['restauracion', 'ocio'],
  'bar-y-cafeteria': ['restauracion'],
  restaurante: ['restauracion'],
  'catering-y-eventos-gastronomicos': ['restauracion'],
  'pasteleria-y-panaderia': ['restauracion', 'comercio', 'alimentacion'],
  'pubs-y-discotecas': ['ocio'],
  'turismo-y-alojamiento': ['hotel', 'ocio'],
  'hotel-y-alojamiento-turistico': ['hotel'],
  'turismo-activo-y-experiencias': ['ocio'],
  comercio: ['comercio', 'ecommerce', 'distribucion'],
  'moda-y-complementos': ['comercio', 'ecommerce'],
  alimentacion: ['comercio', 'ecommerce'],
  'ferreteria-hogar-y-decoracion': ['comercio', 'ecommerce'],
  'belleza-y-cosmetica': ['comercio', 'ecommerce'],
  mascotas: ['comercio', 'ecommerce'],
  deporte: ['comercio', 'ecommerce'],
  'comercio-especializado': ['comercio', 'ecommerce'],
  'distribucion-mayorista-y-suministros-profesionales': ['distribucion'],
  'servicios-profesionales': ['asesoria', 'agencia', 'ingenieria', 'inmobiliaria'],
  'despacho-juridico': ['asesoria'],
  'asesoria-y-gestoria': ['asesoria'],
  'consultoria-empresarial': ['asesoria'],
  'agencia-inmobiliaria': ['inmobiliaria'],
  'agencia-de-marketing-y-comunicacion': ['agencia'],
  'salud-y-bienestar': ['clinica', 'centromed', 'farmacia'],
  'clinica-medica': ['centromed'],
  'clinica-dental': ['clinica'],
  'centro-de-estetica': ['clinica'],
  'fisioterapia-y-rehabilitacion': ['clinica'],
  'farmacia-y-parafarmacia': ['farmacia'],
  'software-y-tecnologia': ['saas', 'softit', 'marketplace', 'apps'],
  'saas-marketplace-y-producto-digital': ['saas', 'marketplace', 'apps'],
  'agencia-de-desarrollo-a-medida': ['softit'],
  'industria-y-manufactura': ['fabricacion', 'metal', 'alimentacion'],
  'carpinteria-y-madera': ['fabricacion'],
  'metalurgia-y-construcciones-metalicas': ['metal'],
  'textil-y-confeccion': ['fabricacion'],
  'produccion-alimentaria': ['alimentacion'],
  'produccion-industrial-especializada': ['fabricacion'],
  'construccion-y-reformas': ['construccion', 'instalador'],
  'empresa-constructora': ['construccion'],
  'reformas-integrales': ['construccion'],
  instalaciones: ['instalador'],
  'pintura-y-acabados': ['construccion'],
  'transporte-y-logistica': ['transporte', 'logistica'],
  'transporte-de-mercancias': ['transporte'],
  'mensajeria-y-ultima-milla': ['transporte'],
  'almacenamiento-y-warehousing': ['logistica'],
  'educacion-y-formacion': ['academia', 'elearning'],
  'servicios-para-empresas-y-particulares': [
    'limpieza',
    'seguridad',
    'mantenimiento',
    'jardineria',
    'ocio',
  ],
  'limpieza-y-mantenimiento': ['limpieza', 'mantenimiento'],
  seguridad: ['seguridad'],
  'jardineria-y-paisajismo': ['jardineria'],
  'gestion-de-residuos-y-reciclaje': ['jardineria'],
  'produccion-de-eventos-y-servicios-audiovisuales': ['ocio'],
};

/** Explicit provisional comparables for catalogue activities absent from Alfredo's 30 profiles.
 * These reuse existing coefficients; they are not sector-specific market calibrations.
 * No catch-all: new catalogue activities must be reviewed and covered by the contract test.
 */
export const SECTOR_COMPARABLES = {
  'lavanderia-y-tintoreria': 'limpieza',
  'agencia-de-viajes': 'agencia',
  estancos: 'comercio',
  'gasolineras-y-estaciones-de-servicio': 'comercio',
  'vending-y-venta-automatica': 'comercio',
  'servicios-financieros-y-seguros': 'asesoria',
  'recursos-humanos-y-seleccion': 'asesoria',
  'peluqueria-y-barberia': 'limpieza',
  'gimnasio-y-centro-deportivo': 'academia',
  veterinaria: 'clinica',
  'laboratorios-dentales-y-protesis': 'fabricacion',
  'servicios-it': 'softit',
  'taller-mecanico': 'mantenimiento',
  'produccion-primaria': 'fabricacion',
  'promotora-inmobiliaria': 'construccion',
  'transporte-de-pasajeros': 'transporte',
  mudanzas: 'transporte',
  'servicios-funerarios': 'asesoria',
  'alquiler-de-maquinaria-y-equipos': 'mantenimiento',
};
Object.entries(SECTOR_COMPARABLES).forEach(([sector, profile]) => {
  SECTOR_PROFILES[sector] = [profile];
});

/** Candidate profiles are private refinements of the existing marketplace answer. */
export const financialProfileOptions = sector =>
  (SECTOR_PROFILES[sector] || []).map(key => ({
    option: key,
    label: methodology.profiles[key].label,
    messageKey: `financialProfile.${key}`,
  }));

/** Ignore stale or tampered refinements which do not belong to the current sector. */
export const resolveFinancialProfile = answers => {
  const keys = SECTOR_PROFILES[answers.sector] || [];
  const key =
    keys.length === 1
      ? keys[0]
      : keys.includes(answers.financialProfile)
      ? answers.financialProfile
      : null;
  if (!key) return null;
  return SECTOR_COMPARABLES[answers.sector]
    ? { ...methodology.profiles[key], comparable: true }
    : methodology.profiles[key];
};
